import { useEffect, useState } from "react";
import {
  getPipelineStatus,
  type PipelineGroup,
} from "@/api/research";

export default function PipelineStatusPanel() {
  const [groups, setGroups] = useState<PipelineGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let active = true;
    getPipelineStatus()
      .then((data) => {
        if (!active) return;
        setGroups(data.groups || []);
        setUnavailable(false);
      })
      .catch(() => {
        if (active) setUnavailable(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const healthy = groups.length > 0 && groups.every((group) => group.healthy);

  return (
    <section className="mt-6 rounded-xl border border-background-200/60 bg-white p-4">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <h2 className="text-sm font-semibold text-foreground-950">研报服务状态</h2>
          <p className="mt-0.5 text-[10px] text-foreground-400">行情、回测、AI 与研报流水线实时状态</p>
        </div>
        {!loading && !unavailable && (
          <span className={`rounded-full px-2 py-1 text-[10px] font-semibold ${
            healthy ? "bg-emerald-50 text-emerald-600" : "bg-amber-50 text-amber-600"
          }`}>
            {healthy ? "运行正常" : "部分服务异常"}
          </span>
        )}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 gap-2">
          {[0, 1, 2, 3].map((item) => (
            <div key={item} className="h-16 animate-pulse rounded-lg bg-background-100" />
          ))}
        </div>
      ) : unavailable ? (
        <div className="rounded-lg bg-background-50 px-3 py-4 text-center text-xs text-foreground-400">
          暂时无法获取服务状态，不影响查看已有研报
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {groups.map((group) => (
            <div key={group.label} className="rounded-lg bg-background-50 p-3">
              <div className="mb-2 flex items-center gap-2">
                <span className={`h-2 w-2 rounded-full ${group.healthy ? "bg-emerald-500" : "bg-amber-500"}`} />
                <span className="text-xs font-semibold text-foreground-700">{group.label}</span>
              </div>
              <div className="space-y-1">
                {group.items.slice(0, 3).map((item) => (
                  <div key={`${group.label}-${item.label}`} className="flex items-center justify-between gap-3 text-[10px]">
                    <span className="truncate text-foreground-400" title={item.hint}>{item.label}</span>
                    <span className={item.healthy ? "text-foreground-700" : "text-amber-600"}>{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
